window.addEventListener('load', () => {
    AOS.init();
    let scrollRef = 0;
});

jQuery(document).ready(function($){

    $('.appliance-slider-section__slider--wrap').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        accessibility: false,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]

    });

    $('.review-slider-section__slider--wrap').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        accessibility: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false
                }
            }
        ]

    });
    $('.gallery-slider-section__slider--wrap').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        accessibility: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,

                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]

    });
    $(':header').each(function() {
        if ($(this).next().is(':header')) {
            $(this).css({'padding-bottom': '0', 'margin-bottom': '10px'});
            $(this).next(':header').css({'padding-top': '0', 'margin-top': '0', 'margin-bottom' : '10px'});
        }
    });


    (function () {
        const header = document.querySelector('.header');
        const icon = document.querySelector('.icon-container');
        icon.onclick = function () {
            header.classList.toggle('menu-open');
        }
    }());

    $(document).on('focus', '.ninja-forms-field', function (e) {
        e.preventDefault();
        $(this).closest('.field-wrap').addClass('focused');
    });

    $(document).on('blur', '.ninja-forms-field', function (e) {
        e.preventDefault();
        var $wrap = $(this).closest('.field-wrap');
        var $input = $wrap.find('.nf-field-element .ninja-forms-field');
        if ($input.val().length == 0)
            $wrap.removeClass('focused');
    });

    $('.card-body').hide();

    $(document).on('click', '.faq-accordion-card .card-top', function (e) {
        var $this = $(this);
        var $activeCard = $('.faq-accordion-card.card-active');
        var $parentCard = $this.closest('.faq-accordion-card');
        console.log($activeCard);

        if ($parentCard.hasClass('card-active')) {
            $parentCard.removeClass('card-active').find('.card-body').slideUp();
        } else {
            $activeCard.removeClass('card-active').find('.card-body').slideUp();
            $parentCard.addClass('card-active').find('.card-body').slideDown();
        }
    });

    function counter(){
        $('.count').each(function(){
            if ($(this).hasClass('start')){
                var elementTop = $(this).offset().top;
                var elementBottom = elementTop + $(this).outerHeight();
                var viewportTop = $(window).scrollTop();
                var viewportBottom = viewportTop + $(window).height();
                if(elementBottom > viewportTop && elementTop < viewportBottom){
                    if(($(this).text()) % 1 === 0){
                        var decimalpoint = 0;
                    }else{
                        var decimalpoint = ($(this).text()).toString().split(".")[1].length;
                    }
                    $(this).removeClass('start');
                    $(this).animate({
                        Counter: $(this).text()
                    },{
                        duration: 4000,
                        easing: 'swing',
                        step: function (now) {
                            $(this).text(now.toFixed(decimalpoint).toLocaleString('en'));
                        }
                    });
                }
            }
        });
    }
    $(document).on('ready', counter);
    $(window).on('scroll', counter);


});

